import { DeckCollectionToolbar } from "~/components/molecules/deck/DeckCollectionToolbar";
import { SearchCards } from "~/components/organisms/card/SearchCards";
import { CompanionDecklist } from "~/components/organisms/deck/decklist/CompanionDecklist";

export const EditTab = () => {
  return (
    <div className="mb-8 flex flex-row animate-in fade-in">
      {/* Advanced search */}
      <div className="grow">
        {/* If author, show extra options */}
        <div className="mb-3">
          <DeckCollectionToolbar />
        </div>
        <SearchCards />
      </div>
      {/* Decklist */}
      <CompanionDecklist />
    </div>
  );
};
